import { AnalyticsService } from './../analytics/analytics.service';
import { ActivatedRoute, NavigationEnd } from '@angular/router';
import { AuthService, User } from './../user/auth.service';
import { FormControl } from '@angular/forms';
import { UnsplashImageService } from './../unsplash/unsplash.service';
import { Urls } from './../unsplash/unsplash.response';
import { RegistryFirebaseService } from './../registry/registry-firebase.service';
import { Component, OnInit, Input, ViewEncapsulation, Output, EventEmitter, OnDestroy, ElementRef, ViewChild } from '@angular/core';
import { Result } from '../unsplash/unsplash.response';
import { RegistryService } from '../registry/registry.service';
import { Subject } from 'rxjs/Subject';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Observable } from 'rxjs/Observable';
import { Router } from '@angular/router';
import { Registry } from '../registry/registry';
import { Gift } from '../gift/gift';

@Component({
  selector: 'app-welcome-popup',
  templateUrl: './welcome-popup.component.html',
  styleUrls: ['./welcome-popup.component.scss'],
  encapsulation: ViewEncapsulation.Emulated,
  host: {
    '(document:keydown)': 'handleKeyboardEvents($event)'
  }
})


export class WelcomePopupComponent implements OnInit {
  @ViewChild('serachQuery') firstNameElement: ElementRef;
  hide: boolean;
  user: User;
  registry: Registry;
  giftUrl: string;
  giftName: string;
  giftImageUrl: string;
    creatingGifts = false;
  @Output() headerPopupEvent: EventEmitter<any>;

  @Input() showPopup = false;
  constructor(private _unsplashImageService: UnsplashImageService,
    private _registryService: RegistryService,
    private _authService: AuthService,
    private router: Router,
    private route: ActivatedRoute,
    private _registryFirebaseService: RegistryFirebaseService,
    private _analyticsService: AnalyticsService

  ) {

    this.router.events.subscribe((event) => {
      let hasSeenPopup = localStorage.getItem('seen_first_gift_success');

      if ((this.router.url.indexOf('registry/how-contributions-work') > -1)) {
        this.giftName =  localStorage.getItem('first_gift_name');
        this.giftImageUrl =  localStorage.getItem('first_gift_image');
    
if(this.router.url.indexOf('/your-registry/how-contributions-work') > -1 && !hasSeenPopup){

    this._registryFirebaseService.registryForUser(this.user).take(1).subscribe(reg => {
      this.registry = reg;

    const firstgirlUrl = localStorage.getItem('first_gift_url');
    if (firstgirlUrl) {
            this.giftUrl = '/your-registry/' +  firstgirlUrl.toLowerCase();
    }
    localStorage.setItem('seen_first_gift_success', "true")

    });

    this.showPopup = true;
    const body = document.getElementsByTagName('body')[0];
    body.style.overflow = 'hidden';

}

        this._authService.user.subscribe(user => {
          if (user) {
            this.user = user;
            const dismiss = user.dismissCreatePopup;
            if (!dismiss && ((this.router.url.indexOf('registry/how-contributions-work') > -1))) {
              this._registryFirebaseService.registryForUser(this.user).take(1).subscribe(reg => {
                this.registry = reg;

              const firstgirlUrl = localStorage.getItem('first_gift_url');
              if (firstgirlUrl) {
                      this.giftUrl = '/'+this.registry.registryName+'/' +  firstgirlUrl.toLowerCase();
              }

              });

              this.showPopup = true;
              const body = document.getElementsByTagName('body')[0];
              body.style.overflow = 'hidden';
            }
          }
        });
      }
        else if(this.router.url.indexOf('/your-registry/how-contributions-work') > -1 && hasSeenPopup){ 
        return this.router.navigate(['/your-registry']);
      } else {

        this.showPopup = false;
      }

    });

  }



  handleKeyboardEvents(event: any) {
    if (this.showPopup && event.keyCode === 27) {

      this.close();
    }



  }



  generateGift(
    title,
    giftTypeSelection,
    price: number,
    location,
    description,
    imageUrl,
    category
  ): Gift {


    const registry = this._registryService._registry;
    const gift = new Gift();
    gift.price = price;
    gift.description = description;
    gift.title = title;
    gift.imageUrl = imageUrl;
    gift.category = category;
    gift.createdFromGiftAssistant = true;
    gift.editedAfterGiftAssistant = false;
    gift.giftTypeSelection = giftTypeSelection;




    if (giftTypeSelection === 'Cash Fund') {
      gift.hidePrice = true;
      gift.price = 99999;
    }
    return gift;
  }



  ngOnInit() {

    this.user = this.route.snapshot.data.user;
    this.registry = this.route.snapshot.data.registry;

    if ((this.router.url.indexOf('/registry/how-contributions-work') > -1)) {
      this.giftName =  localStorage.getItem('first_gift_name');
      this.giftImageUrl =  localStorage.getItem('first_gift_image');

      this.showPopup = true;
    }


    this.router.events.subscribe((event) => {
      if ((this.router.url.indexOf('/registry/how-contributions-work') > -1)) {
        this.giftName =  localStorage.getItem('first_gift_name');
        this.giftImageUrl =  localStorage.getItem('first_gift_image');

        this.showPopup = true;

        const body = document.getElementsByTagName('body')[0];

        //
        body.style.overflow = 'hidden';


      }
    });


  }


  createGift(){
    this.close();
    this.router.navigate(['registry/create-gift']);
  }


  close() {

      this.showPopup = false;
      this.router.navigate(['registry']);
      const body = document.getElementsByTagName('body')[0];
      body.style.overflow = 'auto';
      this._registryService.emitHeaderPopupClosed();


  }

}



// WEBPACK FOOTER //
// ./src/app/welcome-popup/welcome-popup.component.ts